const logos = [
  "https://cdn.prod.website-files.com/67d9b8d389a265b16840fde9/67d9b8d389a265b16840febf_integration-icon-01.svg",
  "https://cdn.prod.website-files.com/67d9b8d389a265b16840fde9/67d9b8d389a265b16840fec1_integration-icon-02.svg",
  "https://cdn.prod.website-files.com/67d9b8d389a265b16840fde9/67d9b8d389a265b16840feac_integration-icon-14.svg",
  "https://cdn.prod.website-files.com/67d9b8d389a265b16840fde9/67d9b8d389a265b16840fec0_integration-icon-08.svg",
  "https://cdn.prod.website-files.com/67d9b8d389a265b16840fde9/67d9b8d389a265b16840febe_integration-icon-15.svg",
  "https://cdn.prod.website-files.com/67d9b8d389a265b16840fde9/67d9b8d389a265b16840feaa_integration-icon-16.svg",
  "https://cdn.prod.website-files.com/67d9b8d389a265b16840fde9/67d9b8d389a265b16840fea5_integration-icon-12.svg",
  "https://cdn.prod.website-files.com/67d9b8d389a265b16840fde9/67d9b8d389a265b16840fea9_integration-icon-10.svg",
  "https://cdn.prod.website-files.com/67d9b8d389a265b16840fde9/67d9b8d389a265b16840feaa_integration-icon-16.svg",
  "https://cdn.prod.website-files.com/67d9b8d389a265b16840fde9/67d9b8d389a265b16840feab_integration-icon-13.svg",
  "https://cdn.prod.website-files.com/67d9b8d389a265b16840fde9/67d9b8d389a265b16840fea4_integration-icon-09.svg",
  "https://cdn.prod.website-files.com/67d9b8d389a265b16840fde9/67d9b8d389a265b16840febe_integration-icon-15.svg",
  "https://cdn.prod.website-files.com/67d9b8d389a265b16840fde9/67d9b8d389a265b16840fead_integration-icon-07.svg",
  
];

const ScrollingLogos = () => {
  const repeated = [...logos, ...logos,...logos,...logos]; // Duplicate logos

  return (
    <div className="w-full py-16 sm:py-32 md:py-48 overflow-hidden space-y-4">
  <h2 className="text-4xl sm:text-3xl md:text-5xl font-bold text-center">
    Connecting Systems <br className="hidden sm:block"/> With Blockchain
  </h2>
  <p className="text-gray-300 mt-4 max-w-2xl mx-auto mb-9 text-sm sm:text-base md:text-lg lg:text-xl leading-relaxed text-center px-4">
    Integrate blockchain seamlessly into your existing systems for enhanced
    security, efficiency, and interoperability.
  </p>
  {/* Scrolling logos section */}

      {/* Top Row - Scroll Left */}
<div className="relative w-full overflow-hidden pt-10">
  <div className="animate-scroll-left whitespace-nowrap flex transform-style">
    {repeated.map((logo, index) => (
      <div
        key={index}
        className="flex items-center justify-center mx-4 shrink-0"
      >
        <img
          src={logo}
          alt="logo"
          className="w-14 h-14 sm:w-36 sm:h-36 object-cover" // 👈 Increased mobile size
        />
      </div>
    ))}
  </div>
</div>

{/* Bottom Row - Scroll Right */}
<div className="relative w-full overflow-hidden">
  <div className="animate-scroll-right whitespace-nowrap flex transform">
    {repeated.map((logo, index) => (
      <div
        key={index}
        className="flex items-center justify-center mx-4 shrink-0"
      >
        <img
          src={logo}
          alt="logo"
          className="w-14 h-14 sm:w-36 sm:h-36 object-cover" // 👈 Increased mobile size
        />
      </div>
    ))}
  </div>
</div>


      {/* Custom Animation Styles */}
      <style jsx="true">{`
        @keyframes scroll-left {
          0% {
            transform: translateX(0%);
          }
          100% {
            transform: translateX(-50%);
          }
        }

        @keyframes scroll-right {
          0% {
            transform: translateX(0%);
          }
          100% {
            transform: translateX(50%);
          }
        }

        .animate-scroll-left {
          animation: scroll-left 10s linear infinite;
        }

        .animate-scroll-right {
          animation: scroll-right 10s linear infinite;
        }
      `}</style>
    </div>

    
  );
};

export default ScrollingLogos;
